import React, { FC } from "react"
import { connect } from "react-redux"
import { CREATE_NEW_DATA, CHANGE_ARRAY_SIZE } from "../../reducers/array"
import { SET_ALGORITHM } from "../../reducers/algorithm"
import { SET_SORTING } from "../../reducers/arrayState"
import { ArrayState } from "../../reducers/types"
import { IStoreState } from "../../reducers"
import { algorithms } from "../Algorithms/constant"
import Controls from "./Controls"

interface ISortingVisualizerProps {
    createNewData: () => void
    array: number[]
    selectedAlgo: string
    isSorting: boolean
    selectAlgorithm: (newAlgorithm: string) => void
    changeArraySize: (newSize: number) => void
    setSorting: (arrayState: ArrayState) => void
}

const SortingVisualizer: FC<ISortingVisualizerProps> = ({
    array,
    selectedAlgo,
    isSorting,
    setSorting,
    selectAlgorithm,
    createNewData,
    changeArraySize,
}: ISortingVisualizerProps) => {
    const onSizeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setSorting(ArrayState.NotSorted)
        changeArraySize(+e.currentTarget.value)
    }

    const onCreateNewData = (): void => {
        setSorting(ArrayState.NotSorted)
        createNewData()
    }

    const onChangeAlgo = (e: React.ChangeEvent<HTMLSelectElement>): void => selectAlgorithm(e.currentTarget.value)
    const onSort = (): void => setSorting(ArrayState.Sorting)
    const onCompletedHandler = (): void => setSorting(ArrayState.Sorted)

    const selectedAlgorithm = algorithms.find((x) => x.value === selectedAlgo)
    const disabled = isSorting || !selectedAlgo

    return (
        <div>
            <Controls
                array={array}
                disabled={disabled}
                onChangeAlgo={onChangeAlgo}
                onCreateNewData={onCreateNewData}
                onSizeChange={onSizeChange}
                onSort={onSort}
                selectedAlgo={selectedAlgo}
                startSort={isSorting}
            />

            <div
                style={{
                    height: "45vh",
                    paddingTop: "10px",
                    width: "100%",
                }}
            >
                {!selectedAlgo && (
                    <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                        <p className="text-lg">{"Please select an algorithm."}</p>
                    </div>
                )}
                {selectedAlgo && !selectedAlgorithm?.component && (
                    <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                        <p className="text-lg">
                            {`I'm currently working on visualizer for `}
                            <span className="font-bold">{`${selectedAlgorithm?.name}.`}</span>
                        </p>
                    </div>
                )}
                {selectedAlgo && selectedAlgorithm?.component && (
                    <selectedAlgorithm.component
                        initialData={array}
                        startSort={isSorting}
                        onComplete={onCompletedHandler}
                    />
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state: IStoreState) => {
    return {
        array: state.array,
        selectedAlgo: state.algorithm,
        isSorting: state.arrayState === ArrayState.Sorting,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        createNewData: () => dispatch({ type: CREATE_NEW_DATA }),
        selectAlgorithm: (newAlgorithm: string) => dispatch({ type: SET_ALGORITHM, payload: newAlgorithm }),
        changeArraySize: (size: number) => dispatch({ type: CHANGE_ARRAY_SIZE, payload: size }),
        setSorting: (arrayState: ArrayState) => dispatch({ type: SET_SORTING, payload: arrayState }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SortingVisualizer)
